import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { BlackInformationChip } from '@/components/Teleprompter/BlackInformationChip';
import DangerCircle from '@/images/DangerCircle.svg';
import Videocamera from '@/images/Videocamera.svg';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;

const InfoContainer = styled.div`
    display: flex;
    align-items: center;
    color: white;
    gap: 8px;
    white-space: nowrap;

    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.36px;
`;

const StyledButton = styled(Button)`
    gap: 4px;
    width: 400px;
`;

interface Props {
    requestDeviceAccess: () => void;
}

export const RequestPermission = ({ requestDeviceAccess }: Props) => {
    const theme = useTheme();

    return (
        <Container>
            <BlackInformationChip>
                <InfoContainer>
                    <MaskedIcon src={DangerCircle} size="32px" color={theme.colors.primary.main} />
                    <div>Your browser needs permission to use your camera and microphone.</div>
                </InfoContainer>
            </BlackInformationChip>
            <StyledButton color="info" onClick={requestDeviceAccess}>
                <MaskedIcon src={Videocamera} size="24px" />
                Grant permission
            </StyledButton>
        </Container>
    );
};
